import eventEnable from '../core/eventEnable';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
const SelectedOptionType = {NBedrooms:'nBedrooms', HouseType:'hosueType',
 PriceRange:'priceRange', Features:'features'};
export default class WhatAreYouLookingForViewModel{
	constructor({siteJsons, houseTypesViewModel, setFilterInSite}){
		this._siteJsons = siteJsons;
		this._availablePlots = this._siteJsons.getPlotsArray().filter(siteJsonsUnitPlot=>siteJsonsUnitPlot.isAvailable);
		this._houseTypesViewModel = houseTypesViewModel;
		this._setFilterInSiteCallback = setFilterInSite;
		this.setFilterInSite = this.setFilterInSite.bind(this);
		this.getPlotsStillAvailableWithOr = this.getPlotsStillAvailableWithOr.bind(this);
		eventEnable(this);
		this._visible = true;
		this._getPlotsAvailableWithOtherSelectedOptions = this._getPlotsAvailableWithOtherSelectedOptions.bind(this);
		this._createIsInPriceRangeLexicalClosure = this._createIsInPriceRangeLexicalClosure.bind(this);
		this._createNBedroomsAvailableWithOtherOptions = this._createNBedroomsAvailableWithOtherOptions.bind(this);
		this._createHouseTypesAvailableWithOtherOptions = this._createHouseTypesAvailableWithOtherOptions.bind(this);
		this._createPriceRangeAvailableWithOtherOptions = this._createPriceRangeAvailableWithOtherOptions.bind(this);
		exposeBinding(this, 'nBedrooms', ()=>this.nBedrooms, (value)=>this.nBedrooms = value);
		exposeBinding(this, 'nBedroomsAvailableWithOtherOptions', ()=>this.nBedroomsAvailableWithOtherOptions);
		exposeBinding(this, 'houseTypes', ()=>this.houseTypes, (value)=>this.houseTypes = value);
		exposeBinding(this, 'houseTypesAvailableWithOtherOptions', ()=>this.houseTypesAvailableWithOtherOptions);
		exposeBinding(this, 'features', ()=>this.features, (value)=>this.features = value);
		exposeBinding(this, 'featuresAvailableWithOtherOptions', ()=>this.featuresAvailableWithOtherOptions);
		exposeBinding(this, 'priceRange', ()=>this.priceRange, (value)=>this.priceRange = value);
		exposeBinding(this, 'priceRangeAvailableWithOtherOptions', ()=>this.priceRangeAvailableWithOtherOptions);
		exposeBinding(this, 'visible', ()=>this.visible, (value)=>this.visible = value);
		exposeBinding(this, 'plotsStillAvailable', ()=>this.getPlotsStillAvailableForSite());
	}
	get visible(){
		return this._visible;
	}
	set visible(value){
		if(this._visible ===value)return;
		this._visible = value;
		this.bindingsHandler.changed('visible', value);
	}
	setFilterInSite(){
		this._setFilterInSiteCallback(this);
	}
	_getPlotsAvailableWithOtherSelectedOptions(selectedOptionTypeFor, siteJson){
		let plotsStillAvailable = this._availablePlots;
		if(siteJson){
			const siteJsonUnitPlotsForSite = siteJson.getPlotsArray();
			plotsStillAvailable = plotsStillAvailable.filter(siteJsonUnitPlot=>siteJsonUnitPlotsForSite.indexOf(siteJsonUnitPlot));
		}
		if(selectedOptionTypeFor!==SelectedOptionType.Bedrooms
			&&this._nBedrooms!==undefined&&this._nBedrooms!==null)
			plotsStillAvailable = plotsStillAvailable.filter(siteJsonsUnitPlot=>
				siteJsonsUnitPlot.nBedrooms===this._nBedrooms);
		if(selectedOptionTypeFor!==SelectedOptionType.HouseType&&this._houseTypes!==undefined&&this._houseTypes!==null&&this._houseTypes.length>0)
		{
			let houseTypes = [];
			this._houseTypes.forEach(houseTypeViewModel=>
				houseTypes = houseTypes.concat(houseTypeViewModel.houseTypesWithSameName)
			);
			plotsStillAvailable = plotsStillAvailable.filter(
				siteJsonsUnitPlot=>houseTypes.indexOf(siteJsonsUnitPlot.houseType)>=0
			)
		}
		if(selectedOptionTypeFor!==SelectedOptionType.PriceRange
			&&this._isInPriceRange){
			plotsStillAvailable = plotsStillAvailable.filter(
				siteJsonsUnitPlot=>this._isInPriceRange(siteJsonsUnitPlot.price)
			);
		}
		if(selectedOptionTypeFor!==SelectedOptionType.Features
			&&this._features!==undefined&&this._features!==null){
			const selectedFeatureIds = this._features.map(feature=>feature.id);
			plotsStillAvailable = plotsStillAvailable.filter(siteJsonsUnitPlot=>{
				for(var feature of siteJsonsUnitPlot.features){
					if(selectedFeatureIds.indexOf(feature.id))
						return true;
				}
				return false;
			});
		}
		return plotsStillAvailable;
	}
	
	get hasFilterApplied(){
		const nBedroomsFilterApplied =  (this._nBedrooms!==null&&this._nBedrooms!==undefined&&this._nBedrooms>0);
		const houseTypesFilterApplied = (this._houseTypes!==null&&this._houseTypes!==undefined&&this._houseTypes.length>0);
		const featuresFilterApplied = (this._features!==null&&this._features!==undefined&&this._features.length>0);
		const priceRangeFilterApplied = (this._priceRange!==null&&this._priceRange!==undefined&&
		!(this._priceRange[0]===this._siteJsons.minPlotPrice&&this._priceRange[1]===this._siteJsons.maxPlotPrice));
		/*console.log('nBedroomsFilterApplied '+nBedroomsFilterApplied);
		console.log('houseTypesFilterApplied '+houseTypesFilterApplied);
		console.log('featuresFilterApplied '+featuresFilterApplied);
		console.log('priceRangeFilterApplied '+priceRangeFilterApplied);
		console.log(this._priceRange);
		console.log(this._minPrice);
		console.log(this._maxPrice);*/
		return nBedroomsFilterApplied||houseTypesFilterApplied||featuresFilterApplied||priceRangeFilterApplied;
	}
	getPlotsStillAvailableForSite(siteJson){
		return this._getPlotsAvailableWithOtherSelectedOptions(null, siteJson);
	}
	getPlotsStillAvailableWithOr(siteJson){
		const siteJsonUnitPlotsForSite = siteJson.getPlotsArray();
		const availablePlots = this._availablePlots.filter(siteJsonsUnitPlot=>
				siteJsonUnitPlotsForSite.indexOf(siteJsonsUnitPlot)>=0);
		let plotsStillAvailable = availablePlots.filter(siteJsonsUnitPlot=>
				siteJsonsUnitPlot.nBedrooms===this._nBedrooms);
		if(this._houseTypes!==undefined&&this._houseTypes!==null){
			let houseTypes = [];
			this._houseTypes.forEach(houseTypeViewModel=>
				houseTypes = houseTypes.concat(houseTypeViewModel.houseTypesWithSameName)
			);
			plotsStillAvailable = plotsStillAvailable.concat(availablePlots.filter(
				siteJsonsUnitPlot=>houseTypes.indexOf(siteJsonsUnitPlot.houseType)>=0
			));
		}
		plotsStillAvailable = plotsStillAvailable.concat(availablePlots.filter(
			siteJsonsUnitPlot=>this._isInPriceRange(siteJsonsUnitPlot.price)
		));
		if(this._features!==undefined&&this._features!==null){
			const selectedFeatureIds = this._features.map(feature=>feature.id);
			plotsStillAvailable = plotsStillAvailable.concat(availablePlots.filter(siteJsonsUnitPlot=>{
				for(var feature of siteJsonsUnitPlot.features){
					if(selectedFeatureIds.indexOf(feature.id))
						return true;
				}
				return false;
			}));
		}
		const oneOfEachPlotsStillAvailable = [];
		plotsStillAvailable.forEach(plotStillAvailable=>{
			if(oneOfEachPlotsStillAvailable.indexOf(plotStillAvailable)<0)
				oneOfEachPlotsStillAvailable.push(plotStillAvailable);
		});
		return plotsStillAvailable;
	}
	get nBedroomsValues(){
		if(this._nBedroomsValues!==undefined&&this._nBedroomsValues!==null)
			return this._nBedroomsValues;
		this._nBedroomsValues =[];
		this._availablePlots.forEach(siteJsonsUnitPlot=>{
			const nBedrooms = siteJsonsUnitPlot.nBedrooms;
			if(this._nBedroomsValues.indexOf(nBedrooms)<0)
				this._nBedroomsValues.push(nBedrooms);
		});
		this._nBedroomsValues.sort((a, b)=>a-b);
		return this._nBedroomsValues;
	}
	get nBedrooms(){
		return this._nBedrooms;
	}
	set nBedrooms(value){
		if(this._nBedrooms===value)return;
		this._nBedrooms = value;
		this.bindingsHandler.changed('nBedrooms', value);
		this._createHouseTypesAvailableWithOtherOptions();
		this._createFeaturesAvailableWithOtherOptions();
		this._createPriceRangeAvailableWithOtherOptions();
		this.bindingsHandler.changed('plotsStillAvailable', this.getPlotsStillAvailableForSite());
	}
	_createNBedroomsAvailableWithOtherOptions(){
		this._nBedroomsAvailableWithOtherOptions = [];
		this._getPlotsAvailableWithOtherSelectedOptions(SelectedOptionType.NBedrooms).forEach(siteJsonsUnitPlot=>{
			const nBedrooms = siteJsonsUnitPlot.nBedrooms;
			if(this._nBedroomsAvailableWithOtherOptions.indexOf(nBedrooms)<0)
				this._nBedroomsAvailableWithOtherOptions.push(nBedrooms);
		});
		this.bindingsHandler.changed('nBedroomsAvailableWithOtherOptions', this._nBedroomsAvailableWithOtherOptions);
	}
	get nBedroomAvailableWithOtherOptions(){
		return this._nBedroomsAvailableWithOtherOptions;
	}
	get houseTypes(){
		return this._houseTypes;
	}
	set houseTypes(value){
		if(this._houseTypes===value)return;
		this._houseTypes = value;
		this.bindingsHandler.changed('houseTypes', value);
		this._createNBedroomsAvailableWithOtherOptions();
		this._createFeaturesAvailableWithOtherOptions();
		this._createPriceRangeAvailableWithOtherOptions();
		this.bindingsHandler.changed('plotsStillAvailable', this.getPlotsStillAvailableForSite());
	}
	_createHouseTypesAvailableWithOtherOptions(){
		const mapHouseTypeToHouseTypeViewModel = new Map();
		this._houseTypesViewModel.entries.forEach(houseTypeViewModel=>{
			houseTypeViewModel.houseTypesWithSameName.forEach(houseType=>{
				if(!mapHouseTypeToHouseTypeViewModel.has(houseType))
					mapHouseTypeToHouseTypeViewModel.set(houseType, houseTypeViewModel);
			});
		});
		this._houseTypeViewModelsStillAvailable = [];
		this._getPlotsAvailableWithOtherSelectedOptions(SelectedOptionType.HouseType).forEach(siteJsonsUnitPlot=>{
			const houseTypeViewModel = mapHouseTypeToHouseTypeViewModel.get(siteJsonsUnitPlot.houseType);
			if(this._houseTypeViewModelsStillAvailable.indexOf(houseTypeViewModel)<0)
				this._houseTypeViewModelsStillAvailable.push(houseTypeViewModel);
		});
		this.bindingsHandler.changed('houseTypesAvailableWithOtherOptions', this._houseTypeViewModelsStillAvailable);
	}
	get houseTypesAvailableWithOtherOptions(){
		return this._houseTypeViewModelsStillAvailable;
	}
	get features(){
		return this._features;
	}
	set features(value){
		if(this._features===value)return;
		this._features = value;
		this.bindingsHandler.changed('features', value);
		this._createNBedroomsAvailableWithOtherOptions();
		this._createHouseTypesAvailableWithOtherOptions();
		this._createPriceRangeAvailableWithOtherOptions();
		this.bindingsHandler.changed('plotsStillAvailable', this.getPlotsStillAvailableForSite());
	}
	_createFeaturesAvailableWithOtherOptions(){
		this._featuresAvailableWithOtherOptions = [];
		this._getPlotsAvailableWithOtherSelectedOptions(SelectedOptionType.Features).forEach(siteJsonsUnitPlot=>{
			siteJsonsUnitPlot.features?.forEach(feature=>{
				if(this._featuresAvailableWithOtherOptions.indexOf(feature)<0)
					this._featuresAvailableWithOtherOptions.push(feature);
			});
		});
		this.bindingsHandler.changed('featuresAvailableWithOtherOptions', this._featuresAvailableWithOtherOptions);
	}
	get featuresAvailableWithOtherOptions(){
		return this._featuresAvailableWithOtherOptions;
	}
	get priceRange(){
		return this._priceRange;
	}
	set priceRange(value){
		if(this._priceRange===value)return;
		this._priceRange = value;
		this._createIsInPriceRangeLexicalClosure();
		this.bindingsHandler.changed('priceRange', value);
		this._createNBedroomsAvailableWithOtherOptions();
		this._createHouseTypesAvailableWithOtherOptions();
		this._createFeaturesAvailableWithOtherOptions();
		this.bindingsHandler.changed('plotsStillAvailable', this.getPlotsStillAvailableForSite());
	}
	_createPriceRangeAvailableWithOtherOptions(){
		const siteJsonsUnitPlots = this._getPlotsAvailableWithOtherSelectedOptions(SelectedOptionType.PriceRange);
		if((!siteJsonsUnitPlots)
			||siteJsonsUnitPlots.length<1) return null;
		this._minPrice=null; this._maxPrice=null;
		siteJsonsUnitPlots.forEach(siteJsonsUnitPlot=>{
			if(this._minPrice===null||siteJsonsUnitPlot.price<this._minPrice)
				this._minPrice = siteJsonsUnitPlot.price;
			if(this._maxPrice===null||siteJsonsUnitPlot.price>this._maxPrice)
				 this._maxPrice = siteJsonsUnitPlot.price;
		});
		this._priceRangeAvailableWithOtherOptions = [this._minPrice, this._maxPrice];
		this.bindingsHandler.changed('priceRangeAvailableWithOtherOptions', this._priceRangeAvailableWithOtherOptions);
	}
	get priceRangeAvailableWithOtherOptions(){
		return this._priceRangeAvailableWithOtherOptions;
	}
	_createIsInPriceRangeLexicalClosure(){
		if(this._priceRange===undefined||this._priceRange===null)
		{
			this._isInPriceRange = null;
			return;
		}
		const from = this._priceRange[0];
		const to = this._priceRange[1];
		if(from!==undefined&&from!==null){
			if(to!==undefined&&to!==null){
				this._isInPriceRange = (price)=>{
					return (price>=from)&&(price<=to);
				};
				return;
			}
			this._isInPriceRange = (price)=>price>=from;
			return;
		}
		if(to!==undefined&&to!==null){
			this._isInPriceRange = (price)=>price<=to;
			return;
		}
		this._isInPriceRange = null;
	}
}